var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIconType({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6936 4.36028C13.5072 3.54668 14.8263 3.54668 15.6399 4.36028C16.4535 5.17387 16.4535 6.49296 15.6399 7.30655L12.5149 10.4316C11.7013 11.2451 10.3822 11.2451 9.56859 10.4316C9.16179 10.0248 8.50225 10.0248 8.09545 10.4316C7.68865 10.8383 7.68865 11.4979 8.09545 11.9047C9.72263 13.5319 12.3608 13.5319 13.988 11.9047L17.113 8.77969C18.7402 7.15251 18.7402 4.51432 17.113 2.88714C15.4858 1.25995 12.8476 1.25995 11.2205 2.88714L9.65795 4.44964C9.25115 4.85643 9.25115 5.51598 9.65795 5.92277C10.0647 6.32957 10.7243 6.32957 11.1311 5.92277L12.6936 4.36028Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48527 9.56861C8.29887 8.75502 9.61796 8.75502 10.4316 9.56861C10.8383 9.9754 11.4979 9.9754 11.9047 9.56861C12.3115 9.16181 12.3115 8.50226 11.9047 8.09547C10.2775 6.46828 7.63932 6.46828 6.01214 8.09547L2.88714 11.2205C1.25995 12.8477 1.25995 15.4858 2.88714 17.113C4.51432 18.7402 7.15251 18.7402 8.77969 17.113L10.3422 15.5505C10.749 15.1437 10.749 14.4842 10.3422 14.0774C9.9354 13.6706 9.27585 13.6706 8.86905 14.0774L7.30655 15.6399C6.49296 16.4535 5.17387 16.4535 4.36028 15.6399C3.54668 14.8263 3.54668 13.5072 4.36028 12.6936L7.48527 9.56861Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIconType);
export default __webpack_public_path__ + "static/media/link-icon-type.64f2de5ae7770249f22fe4c1916304bd.svg";
export { ForwardRef as ReactComponent };